<div class="app-layout">
  @if (isAuthenticated()) {
    <app-sidebar />
  }
  <main class="app-content">
    @if (isAuthenticated()) {
      <app-topbar />
    }
    <div class="app-content-wrapper">
      <router-outlet />
    </div>
  </main>
</div>
<app-toast-layer />
